import { useMutation } from 'react-query';
import request from '../../../../../helpers/request';

const createPermit = async (value) => {
  const { expireDate, ...rest } = value || {};

  return await request.post(
    'Access/transport',
    { ...rest, ...(!!expireDate ? { expireDate } : {}) },
    'При создании пропуска произошла ошибка',
    'Error'
  );
};

const useCreatePermit = (onSuccess) =>
  useMutation(createPermit, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      if (typeof onSuccess === 'function') onSuccess();
    },
  });

export default useCreatePermit;
